export const LOGS_SET_LIST_DATA = 'LOGS_SET_LIST_DATA';
export const LOGS_SET_LIST_META = 'LOGS_SET_LIST_META';
export const LOGS_TITLE="Nhật ký hệ thống";